<ng-container *ngIf="state.jobId">
  <div y42JobInfoHost [jobIds]="[state.jobId]"></div>
</ng-container>
